import { useState } from 'react';
import { useRole } from '../../lib/role.tsx';
import { canDoCashbox } from '../../lib/cashboxApi.js';
import { CashboxDashboard } from './cashbox/CashboxDashboard.js';
import { CashboxOperations } from './cashbox/CashboxOperations.js';
import { CashboxShifts } from './cashbox/CashboxShifts.js';
import { CashboxReports } from './cashbox/CashboxReports.js';
import { CashboxArchive } from './cashbox/CashboxArchive.js';
import { CashboxImport } from './cashbox/CashboxImport.js';
import { CashboxAudit } from './cashbox/CashboxAudit.js';
import { CashboxSettings } from './cashbox/CashboxSettings.js';
import { OperationModal } from './cashbox/OperationModal.js';

type CashTab =
  | 'main'
  | 'operations'
  | 'shifts'
  | 'reports'
  | 'archive'
  | 'import'
  | 'audit'
  | 'settings';

const CASH_TAB_DEFS: {
  id: CashTab;
  label: string;
  action?: Parameters<typeof canDoCashbox>[1];
}[] = [
  { id: 'main',       label: 'Главный' },
  { id: 'operations', label: 'Операции' },
  { id: 'shifts',     label: 'Смены' },
  { id: 'reports',    label: 'Отчёты',   action: 'report' },
  { id: 'archive',    label: 'Архив' },
  { id: 'import',     label: 'Импорт',   action: 'import' },
  { id: 'audit',      label: 'Аудит',    action: 'audit' },
  { id: 'settings',   label: 'Настройки', action: 'settings' },
];

export function CashSubscreen() {
  const role = useRole();
  const [tab, setTab] = useState<CashTab>('main');
  const [showNewOp, setShowNewOp] = useState(false);

  const visibleTabs = CASH_TAB_DEFS.filter(
    (t) => !t.action || canDoCashbox(role, t.action),
  );

  // If current tab is not visible after role change, fallback to main
  const activeTab = visibleTabs.find((t) => t.id === tab) ? tab : 'main';

  return (
    <div className="content">
      {/* Inner tab bar */}
      <div className="cashbox-tabs" data-testid="cashbox-tabs">
        {visibleTabs.map((t) => (
          <button
            key={t.id}
            className="cashbox-tab"
            data-active={activeTab === t.id}
            onClick={() => setTab(t.id)}
            data-testid={`cashbox-tab-${t.id}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      {activeTab === 'main' && (
        <CashboxDashboard onNewOperation={() => { setTab('operations'); setShowNewOp(true); }} />
      )}
      {activeTab === 'operations' && <CashboxOperations />}
      {activeTab === 'shifts' && <CashboxShifts />}
      {activeTab === 'reports' && <CashboxReports />}
      {activeTab === 'archive' && <CashboxArchive />}
      {activeTab === 'import' && <CashboxImport />}
      {activeTab === 'audit' && <CashboxAudit />}
      {activeTab === 'settings' && <CashboxSettings />}

      {showNewOp && (
        <OperationModal onClose={() => setShowNewOp(false)} />
      )}
    </div>
  );
}
